import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useDispatch, useSelector } from "react-redux"

import { faCircleArrowDown, faEdit } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import Backdrop from "../../../Backdrop"
import InfoIcon from "../../../InfoIcon"
import Filter from "./mobile/filter"

export default function MobileComponent() {


    const [mobileItems, setMobileItems] = useState()


    let filteredproducts = useSelector((state) => state.product.filteredProducts)

    let dispatch = useDispatch()

   

    let stateproducts = useSelector(state => state.product.products)


    useEffect(() => {

        let items = []
        let products = filteredproducts ?? stateproducts

        if (products && Object.keys(products).length > 0) {

            products.forEach((product) => {

                items.push(<MobileItem key={product.id} product={product} />)

            })
        }
        setMobileItems(items)



    }, [filteredproducts, stateproducts])


    if (!mobileItems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            {mobileItems}
        </Filter>
        <Backdrop />
    </Fragment>
}


function MobileItem(props) {
    const { product } = props

    const [showContent, setShowContent] = useState(false)


    return <Fragment>

            <div className="card shadow  bg-white rounded p-3" style={{ cursor: 'pointer' }} onClick={() => {
                setShowContent(!showContent)
            }}  >
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }} >
                    <span>{product.title}</span>
                    <span>{product.active}</span>
                    <span>{product.ptype}</span>
                </div>
                <InfoIcon icon={faCircleArrowDown} size='xl' />

            </div>
            {showContent &&
                <table className="table table-striped table-bordered" >
                    <tbody>
                        <tr>
                            <th>Title</th>
                            <td>
                                {product.title}
                            </td>
                        </tr>
                        <tr>
                            <th>Active</th>

                            <td>
                                {product.active?'true':'false'}
                            </td>
                        </tr>
                        <tr>
                            <th>Type</th>
                            <td>
                            <Link to={`/admin/producttypes/${product.type_id}`} >{product.ptype}</Link>
                            </td>
                        </tr>
                        <tr>
                            <th>Start</th>
                            <td>
                                {product.start}
                            </td>
                        </tr>
                      <tr>
                      <th>End</th>
                        <td>
                            {product.end}
                        </td>
                      </tr>
                        <tr>
                            
                            <th>Edit</th>
                            <td>
                                <Link className="btn btn-outline-secondary bgnt" to={`/admin/products/${product.id}`} ><InfoIcon icon={faEdit} title='product details' /></Link>
                            </td>

                        </tr>

                    </tbody>
                </table>
            }


    </Fragment>

}